import React, { useState } from "react";
import emailjs from "emailjs-com";

const Contact = () => {
	const [formData, setFormData] = useState({
		topic: "",
		description: "",
		email: "",
	});

	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value,
		});
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		// Prepare form data for EmailJS
		const { topic, description, email } = formData;

		// Send form data to EmailJS
		emailjs
			.sendForm(
				"service_1xpyk2j",
				"template_zhm3ire",
				e.target,
				"MQ4XfGij2uwgufgT7",
				{
					from_name: email,
					topic: topic,
					message: description,
				}
			)
			.then(
				(result) => {
					console.log(result.text);
					// Handle success (e.g., display a success message)
				},
				(error) => {
					console.log(error.text);
					// Handle error (e.g., display an error message)
				}
			);

		// Reset form fields
		setFormData({ topic: "", description: "", email: "" });
	};

	return (
		<div className="max-w-7xl mx-auto px-10 pb-10">
			<h1 className="text-xl sm:text-2xl font-bold text-center mb-16 text-gray-800 border border-gray-800 rounded-2xl py-3">
				Contact Us
			</h1>

			{/* Send Us a Message Section */}
			<section className=" mb-28">
				<h2 className="text-xl font-semibold mb-10 text-gray-800 text-center">
					Send Us a Message
				</h2>
				<form onSubmit={handleSubmit} className="space-y-10">
					{/* Floating Label Input: Topic */}
					<div className="relative z-0 w-full group">
						<input
							type="text"
							id="topic"
							name="topic"
							className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
							placeholder=" "
							value={formData.topic}
							onChange={handleChange}
							required
						/>
						<label
							htmlFor="topic"
							className="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 peer-focus:text-blue-600"
						>
							Topic
						</label>
					</div>

					{/* Floating Label Input: Description */}
					<div className="relative z-0 w-full group">
						<textarea
							id="description"
							name="description"
							rows="4"
							className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
							placeholder=" "
							value={formData.description}
							onChange={handleChange}
							required
						></textarea>
						<label
							htmlFor="description"
							className="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 peer-focus:text-blue-600"
						>
							Description
						</label>
					</div>

					{/* Floating Label Input: Email */}
					<div className="relative z-0 w-full group">
						<input
							type="email"
							id="email"
							name="email"
							className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
							placeholder=" "
							value={formData.email}
							onChange={handleChange}
							required
						/>
						<label
							htmlFor="email"
							className="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 peer-focus:text-blue-600"
						>
							Your Email
						</label>
					</div>

					{/* Submit Button */}
					<button
						type="submit"
						className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 transition duration-300 text-base font-semibold"
					>
						Send Message
					</button>
				</form>
			</section>

			{/* Contact Information Section */}
			<section className="bg-black px-8 py-12 rounded-2xl mb-10">
				<h2 className="text-2xl font-semibold mb-8 text-white text-center border-b border-gray-200 pb-6">
					Contact Information
				</h2>
				<div className="grid grid-cols-1 md:grid-cols-3 gap-8">
					{/* Ethiopian Phone */}
					<div className="text-center">
						<p className="text-base text-gray-300">
							<strong className="text-white font-semibold">
								Ethiopian Phone:
							</strong>{" "}
							<span className="block mt-2 text-blue-400">
								+251 96 248 9700
							</span>
						</p>
					</div>

					{/* International Phone */}
					<div className="text-center">
						<p className="text-base text-gray-300">
							<strong className="text-white font-semibold">
								International Phone:
							</strong>{" "}
							<span className="block mt-2 text-blue-400">
								+ 1 (425) 663-0218
							</span>
						</p>
					</div>

					{/* Email */}
					<div className="text-center">
						<p className="text-base text-gray-300">
							<strong className="text-white font-semibold">
								Email:
							</strong>{" "}
							<a
								href="mailto:Ecybernest@gmail.com"
								className="block mt-2 text-blue-500 underline hover:text-blue-700 transition duration-300"
							>
								Ecybernest@gmail.com
							</a>
						</p>
					</div>
				</div>
			</section>
		</div>
	);
};

export default Contact;
